<template>
  <div>
    <FilterObject
      v-for="filter in filters"
      :filter="filter"
      @change="updateFilters"
      @delete="deleteFilter"
      :key="filter.id"
    />
    <v-btn @click="addFilter">
      <i class="fal fa-filter" style="margin-right:5px;"></i> Add filter
    </v-btn>
  </div>
</template>

<script>
import FilterObject from "./FilterObject";

export default {
  data() {
    return {
      filters: [],
    };
  },
  methods: {
    addFilter() {
      this.filters.push({
        id: this.createID(),
        column: "",
        operator: "==",
        value: "",
      });
    },
    updateFilters(filter) {
      var index = filter.index;

      this.filters[index] = {
        column: filter.column,
        operator: filter.operator,
        value: filter.value,
      };

      this.$emit("newfilters", this.filters);
    },
    deleteFilter(filter_id) {
      this.filters.forEach(function (filter, index) {
        if (filter.id === filter_id) {
          this.filters[index] = null;
        }
      }.bind(this));

      this.filters = this.filters.filter((current) => {
        return current != null;
      });

      setTimeout(function() {
        this.$emit("newfilters", this.filters);
      }.bind(this), 1200);
    },
    createID() {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    },
  },
  components: {
    FilterObject,
  },
};
</script>

<style>
</style>